import { Button } from "@mui/material";
import { Event } from "@mui/icons-material";

interface ScheduleButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function ScheduleButton({ onClick }: ScheduleButtonProps) {
  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={<Event />}
      onClick={onClick}
      sx={{
        padding: "4px 12px",
        minHeight: "28px",
        fontSize: "0.8125rem",
        borderColor: "primary.main",
        color: "primary.main",
        "&:hover": {
          borderColor: "primary.dark",
          backgroundColor: "action.hover",
        },
        "& .MuiButton-startIcon": {
          marginRight: "4px",
          marginLeft: 0,
        },
      }}
    >
      Harmonogram
    </Button>
  );
}
